/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useMemo, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { ColDef, FormDataPicker, FormInputNumber, FormRadio, PaginationStd, TableSetting, TableStd, ToolbarSetting } from 'app/components'
import React from 'react'
import { SystemDateDisplayFormat, UserProfileService, SelfValidateFilterDto, SelfAssessValidateDto, SelfAssessService, Pattern, ValidateUpdateRequestDto, SeasonService, AssessTypeEnum, API_IMG_SPECIAL_FILE } from 'app/modules/core'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { ImageAvatar } from 'app/components/images/ImageAvatar'
import { useGlobalModalContext } from 'setup/context/GlobalModal'
import { toast } from 'react-toastify'
import { catchErrorMsg } from 'app/modules/core/helpers/Helper'
import { KTSVG, toAbsoluteUrl } from '_metronic/helpers'
import { object } from 'yup'
import InputNumber from 'app/components/input/input-number/InputNumber'
import { ModalBox } from 'app/components/modals/ModalBox'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { MenuComponent } from '_metronic/assets/ts/components'

interface IFormEditPoint {
    isShow: boolean,
    id?: number,
    newPoint: number,
    remark: string,
    isLoad: boolean
}

const SelftSettingValidatePage: FC = () => {

    const msgBox = useGlobalModalContext()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [reload, setReload] = React.useState<{}>()
    const [data, setData] = useState<Array<SelfAssessValidateDto>>([])
    const [totalRow, setTotalRow] = useState(0)
    const [searchParam, setSearchParam] = useState<SelfValidateFilterDto>({
        page: 0,
        length: 10
    })
    const [season, setSeason] = useState<{ value: string, label: string }[]>([])
    const initEditPoint: IFormEditPoint = {
        isShow: false,
        id: undefined,
        newPoint: 0,
        remark: '',
        isLoad: false
    }

    const formSchema = Yup.object().shape({
        newPoint: Yup.number().required('require'),
        remark: Yup.string().required('require'),
    })

    const [showModal, setShowModal] = useState<IFormEditPoint>(initEditPoint)


    useMemo(() => {
        SeasonService.GetActiveSeasons().then(res => {
            const opts: { value: string, label: string }[] = []
            res.data.result.map((item) =>
                opts.push({ value: item.id.toString(), label: item.title })
            )
            setSeason(opts)
        })
    }, [])


    const columnDef: ColDef<SelfAssessValidateDto>[] = [
        {
            label: 'Id',
            renderItem: ({ item }) => item.id,
           
        },
        {
            label: 'SeasonId',
            hidden: true,
            renderItem: ({ item }) => item.seasonId,
            filterOption: season,
        },
        {
            label: 'Season',
            renderItem: ({ item }) => item.seasonName,
        },

        {
            label: 'userProfileId',
            hidden: true,
            renderItem: ({ item }) => item.userProfileId,
        },
        {
            label: 'ชื่อ',
            renderItem: ({ item }) => item.userProfileName,
        },
        {
            label: 'วันที่',
            renderItem: ({ item }) => moment(item.recordDate).format("YYYY-MMM"),
            hasTextFilter: true

        },
        {
            label: 'รายละเอียด',
            renderItem: ({item}) => <div>
                <div>{item.title}</div>
                {item.file && <div><img src={toAbsoluteUrl(`${API_IMG_SPECIAL_FILE}/${item.file}`)} alt="Metronic logo" className="img-fluid img-thumbnail" /></div>}
                
            </div>,
        },
        {
            label: 'ประเภทการประเมิน',
            renderItem: ({ item }) => {
                switch (item.assessTypeId) {
                    case AssessTypeEnum.self:
                        return <>{'ประเมินตนเอง'}</>
                    case AssessTypeEnum.spacial:
                        return <>{'คะแนนพิเศษ'}</>
                    default:
                        return <></>
                }
            },
            filterOption: [
                { value: AssessTypeEnum.self, label: 'ประเมินตนเอง' },
                { value: AssessTypeEnum.spacial, label: 'คะแนนพิเศษ' },

            ],
        },
        {
            label: 'ประเภท',
            renderItem: ({ item }) => {
                switch (item.category) {
                    case 'Late':
                        return <>{'มาสาย'}</>
                    case 'Leave':
                        return <>{'ลา'}</>
                    case 'Issue':
                        return <>{'แฟ้ม'}</>
                    case 'Stat':
                        return <>{'สถิติ'}</>
                    default:
                        return <></>
                }

            },
            filterOption: [
                { value: 'Late', label: 'มาสาย' },
                { value: 'Leave', label: 'ลา' },
                { value: 'Issue', label: 'แฟ้ม' },
                { value: 'Stat', label: 'สถิติ' },
            ],
        },
        {
            label: 'คะแนน',
            width: '15%',
            renderItem: ({ item }) => item.point
        },

        {
            label: 'history',
            width: '15%',
            renderItem: ({ item }) => <textarea defaultValue={item.pointBeforeChange} rows={4} disabled={true} className='fw-6' style={{ overflow: 'scroll', wordWrap: 'normal', whiteSpace: 'pre' }}>

            </textarea>
        },


        {
            label: '',
            renderItem: ({ item }) => <>
                <div className='text-center'>
                    <button
                        type='button'
                        onClick={(e) => setShowModal({
                            isShow: true,
                            id: item.id,
                            newPoint: item.point,
                            remark: '',
                            isLoad: false
                        })
                        }
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                        <KTSVG
                            path='/media/icons/duotune/art/art005.svg'
                            className='svg-icon-3'
                        />
                    </button>

                    <button
                        type='button'
                        onClick={(e) => onDelete(item.id)
                        }
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                        <KTSVG
                            path='/media/icons/duotune/general/gen027.svg'
                            className='svg-icon-3'
                        />
                    </button>
                </div>
            </>
        },
    ]

    const tableSetting: TableSetting<SelfAssessValidateDto> = {
        showColAction: false,

        onBtnDeleteClick(e, id) {
            msgBox.showModal({ title: 'Warning', message: 'Are you sure you want to delete.' }, (type) => {
                if (type === 'ok') {
                    UserProfileService.Delete(id).then((res) => {
                        toast.success('Delete Success.')
                        setReload({})
                    })
                        .catch((res) => {
                            toast.error(catchErrorMsg(res))
                        })
                }
            })
        },
        primaryKey: (item: SelfAssessValidateDto) => item.id,
    }
    const toolbarSetting: ToolbarSetting = {
        showBtnAdd: false,
        showFilter: true,
        showSearch: true,
        btnAddText: 'เพิ่มใหม่',
        searchTextValue: '',
        onFilterApply: (val: { label: string; value: any }[]) => {
            const category = val.find((x) => x.label === 'ประเภท')?.value
            const seasonId = val.find(x => x.label === 'SeasonId')?.value
            const recordDate = val.find(x => x.label === 'วันที่')?.value
            const assessTypeId = val.find(x => x.label === 'ประเภทการประเมิน')?.value
            setSearchParam((s) => ({
                ...s,
                category: category ? category : undefined,
                seasonId: seasonId ? seasonId : undefined,
                recordDate: recordDate ? recordDate : undefined,
                assessTypeId: assessTypeId ? assessTypeId : undefined,
                page: 0
            }))
        },
        onSearchTextChange: (e: any) => {
            setSearchParam((s) => ({
                ...s,
                searchText: e.target.value,
                page: 0
            }))
        }

    }

    useEffect(() => {
        const load = () => {
            setLoading(true)
            SelfAssessService.SearchSelfSettingValidate(searchParam).then((result) => {
                const row = result.data.result
                setTotalRow(result.data.totalRows)
                setData(row)
                setLoading(false)
                MenuComponent.reinitialization()
            }).catch((ex) => {
                setLoading(false)
                MenuComponent.reinitialization()
            })
        }
        load()
    }, [searchParam, reload])


    const CellStyle: React.FC<{ lable: string, children?: React.ReactNode, labelCls?: string, inputCls?: string, txtEndCls?: string, textEnd?: string }> = (props) => {
        const labelCls = props.labelCls ?? 'col-lg-6 fw-bold'
        const inputCls = props.inputCls ?? 'col-lg-6'
        return (
            <div className='row mb-7'>
                <label className={labelCls}>{props.lable}</label>
                <div className={inputCls}>
                    <span className='fw-bolder fs-6 text-dark'>{props.children}</span>

                </div>
                {props.textEnd && <div className={props.txtEndCls}>
                    <span > {props.textEnd}</span>
                </div>}
            </div>
        )
    }

    const onSubmit = async (values: IFormEditPoint) => {
        setLoading(true)
        setShowModal({ ...showModal, isLoad: true })
        if (values.id) {
            const model: ValidateUpdateRequestDto = {
                newPoint: values.newPoint,
                remark: values.remark
            }
            SelfAssessService.UpdateSelfValidate(values.id, model).then(() => {
                toast.success('Update Success.')
                setShowModal({ ...showModal, isLoad: false, isShow: false })
                setLoading(false)
                setReload({})
            }).catch((res) => {

                toast.error(catchErrorMsg(res))
                setShowModal({ ...showModal, isLoad: false })
                setLoading(false)
            })
        }

    }


    const onDelete = (id: number) => {
        setLoading(true)
        SelfAssessService.DeleteSelfValidate(id).then(() => {
            toast.success('Deleted Success.')

            setReload({})
            setLoading(false)
        }).catch((res) => {
            toast.error(catchErrorMsg(res))
            setLoading(false)
        })
    }

    return (
        <>
            <PageTitle breadcrumbs={[]}></PageTitle>
            <div className={`card mb-5 mb-xl-8`}>

                {/* begin::Body */}
                <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div >
                        {/* begin::Table */}
                        <TableStd
                            tableSetting={tableSetting}
                            toolbarSetting={toolbarSetting}
                            columns={columnDef}
                            data={data}
                            isLoading={loading}
                        />
                        {/* end::Table */}
                    </div>
                    <div>
                        <PaginationStd
                            pageSetting={{
                                currentPage: searchParam.page,
                                totalRow: totalRow,
                                pageSize: 10,
                            }}
                            onPageChange={(e: any, page: number) => setSearchParam({
                                ...searchParam,
                                page
                            })}
                            isLoading={loading}
                        />
                    </div>
                    {/* end::Table container */}
                </div>
                {/* begin::Body */}
            </div>
            {showModal.isShow && (
                <ModalBox
                    title={'แก้ไขการประเมินตนเอง'}
                    stateShow={showModal.isShow}
                    onHide={() => setShowModal({ ...showModal, isShow: false })}
                    showOK={false}
                    txtCancel='Close'
                    showCancel={true}
                >
                    <Formik
                        enableReinitialize
                        initialValues={showModal}
                        validationSchema={formSchema}
                        onSubmit={onSubmit}
                    >
                        {({ values, handleSubmit, setFieldValue, errors, touched }) => (
                            <Form>
                                <>
                                    {/* begin::Scroll */}
                                    <div className='card-body p-9'>
                                        <CellStyle lable='แก้ไข Point เป็น'>
                                            <Field
                                                name='newPoint'
                                                className={
                                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                    (errors.newPoint && touched.newPoint ? ' is-invalid' : '')
                                                }
                                                maxLength={18}
                                                pattern={Pattern.Number2DigitMinus}
                                                component={FormInputNumber}
                                            />
                                            <ErrorMessage name={`newPoint`} component='div' className='text-danger' />
                                        </CellStyle>
                                        <CellStyle lable='Remark'>
                                            <Field
                                                as='textarea'
                                                autoComplete='off'
                                                name='remark'
                                                className={
                                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                    (errors.remark && touched.remark ? ' is-invalid' : '')
                                                }
                                                rows={3}
                                            />
                                            <ErrorMessage name={`remark`} component='div' className='text-danger' />
                                        </CellStyle>

                                    </div>
                                    {/* end::Scroll */}

                                    <div className='card-footer d-flex py-6 px-9'>
                                        <button type='submit' className='btn btn-primary pe-5  me-10' disabled={values.isLoad}>
                                            {!values.isLoad && 'Save Changes'}
                                            {values.isLoad && (
                                                <span className='indicator-progress' style={{ display: 'block' }}>
                                                    Please wait...
                                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                </span>
                                            )}
                                        </button>

                                    </div>
                                </>
                            </Form>
                        )}
                    </Formik>

                </ModalBox>)}

        </>
    )
}
export { SelftSettingValidatePage }
